import React from 'react';
import {
  Box,
  Radio,
  BoxProps,
  useRadioGroupContext,
  RadioProps,
} from '@chakra-ui/react';

export const StyledRadioCard = ({
  value,
  isDisabled = false,
  children,
  ...rest
}: BoxProps & Pick<RadioProps, 'value' | 'isDisabled'>) => {
  const group = useRadioGroupContext();
  const isSelected = group?.value === value;

  return (
    <Box
      as="label"
      outline="transparent solid 2px"
      outlineOffset="2px"
      borderWidth={1}
      borderRadius="8px"
      _hover={
        !isDisabled
          ? {
              textDecoration: 'none',
              bg: 'kblue.50',
              cursor: 'pointer',
            }
          : {}
      }
      backgroundColor={isSelected ? 'kblue.50' : 'none'}
      borderColor={isSelected ? 'kblue.400' : 'kgray.200'}
      width="100%"
      cursor={!isDisabled ? 'pointer' : 'default'}
      {...rest}
    >
      <Radio value={value} isDisabled={isDisabled} size="md" width="100%">
        {children}
      </Radio>
    </Box>
  );
};
